module.exports = __webpack_public_path__ + "media/images/idle_logo-8efc8e841d21ab719974a7133a5908e3.jpeg";